export function isDefrentProductData (oldData, newData) {
    if(oldData.length!==newData.length) return true;
    const oldid = (oldData || []).map(i=> i.id)
    const newid = (newData || []).map(i=>i.id)
    const oldtitle = (oldData || []).map(i=> i.title)
    const newtitle = (newData || []).map(i=>i.title)
    const olddescription = (oldData || []).map(i=> i.description)
    const newdescription = (newData || []).map(i=>i.description)
    const oldchat = (oldData || []).map(i=> i.chat)
    const newchat = (newData || []).map(i=>i.chat)
    const oldcall = (oldData || []).map(i=> i.call)
    const newcall = (newData || []).map(i=>i.call)
    const oldlike = (oldData || []).map(i=> i.like)
    const newlike = (newData || []).map(i=>i.like)
    const oldfilter = (oldData || []).map(i=> i.filter)
    const newfilter = (newData || []).map(i=>i.filter)
    const oldfilterId = (oldfilter || []).map(i=> i.id)
    const newfilterId = (newfilter || []).map(i=> i.id)
    const oldfilterTitle = (oldfilter || []).map(i=>i.title)
    const newfilterTitle = (newfilter || []).map(i=>i.title)
    const oldcreated_at = (oldData || []).map(i=> i.created_at)
    const newcreated_at = (newData || []).map(i=>i.created_at)
    const oldlocation = (oldData || []).map(i=> i.location)
    const newlocation = (newData || []).map(i=>i.location)
    const oldlocationcity = (oldlocation || []).map(i=> i.city)
    const newlocationcity = (newlocation || []).map(i=>i.city)
    const oldlocationlat = (oldlocation || []).map(i=> i.lat)
    const newlocationlat = (newlocation || []).map(i=>i.lat)
    const oldlocationlon = (oldlocation || []).map(i=> i.lon)
    const newlocationlon = (newlocation || []).map(i=>i.lon)
    const oldlocationaddress = (oldlocation || []).map(i=> i.address)
    const newlocationaddress = (newlocation || []).map(i=>i.address)
    const oldcategory = (oldData || []).map(i=> i.category)
    const newcategory = (newData || []).map(i=>i.category)
    const oldcategorytitle = (oldcategory || []).map(i=> i.title)
    const newcategorytitle = (newcategory || []).map(i=>i.title)
    const olduser = (oldData || []).map(i=> i.user)
    const newuser = (newData || []).map(i=>i.user)
    const oldusername = (olduser || []).map(i=> i.name)
    const newusername = (newuser || []).map(i=>i.name)
    const olduserfamily = (olduser || []).map(i=> i.family)
    const newuserfamily = (newuser || []).map(i=>i.family)
    const olduserphone = (olduser || []).map(i=> i.phone)
    const newuserphone = (newuser || []).map(i=>i.phone)
    const olduserimage = (olduser || []).map(i=> i.image)
    const newuserimage = (newuser || []).map(i=>i.image)
    const oldmedias = (oldData || []).map(i=> i.medias)
    const oldmediasurl = (oldmedias || []).map(i=>i.url)
    const newmedias = (newData || []).map(i=>i.medias)
    const newmediasurl = (newmedias || []).map(i=>i.url)
    return JSON.stringify(newid)!==JSON.stringify(oldid) ||
    JSON.stringify(newtitle)!==JSON.stringify(oldtitle) ||
    JSON.stringify(newdescription)!==JSON.stringify(olddescription) ||
    JSON.stringify(newlike)!==JSON.stringify(oldlike) ||
    JSON.stringify(oldchat)!==JSON.stringify(newchat) ||
    JSON.stringify(newcall)!==JSON.stringify(oldcall) ||
    JSON.stringify(newfilter)!==JSON.stringify(oldfilter) ||
    JSON.stringify(oldfilterId)!==JSON.stringify(newfilterId) ||
    JSON.stringify(oldfilterTitle)!==JSON.stringify(newfilterTitle) ||
    JSON.stringify(newcreated_at)!==JSON.stringify(oldcreated_at) ||
    JSON.stringify(newlocation)!==JSON.stringify(oldlocation) ||
    JSON.stringify(oldlocationcity)!==JSON.stringify(newlocationcity) ||
    JSON.stringify(oldlocationlat)!==JSON.stringify(newlocationlat) ||
    JSON.stringify(oldlocationlon)!==JSON.stringify(newlocationlon) ||
    JSON.stringify(oldlocationaddress)!==JSON.stringify(newlocationaddress) ||
    JSON.stringify(newcategory)!==JSON.stringify(oldcategory) ||
    JSON.stringify(newcategorytitle)!==JSON.stringify(oldcategorytitle) ||
    JSON.stringify(newuser)!==JSON.stringify(olduser) ||
    JSON.stringify(oldusername)!==JSON.stringify(newusername) ||
    JSON.stringify(olduserfamily)!==JSON.stringify(newuserfamily) ||
    JSON.stringify(olduserphone)!==JSON.stringify(newuserphone) ||
    JSON.stringify(olduserimage)!==JSON.stringify(newuserimage) ||
    JSON.stringify(oldmediasurl)!==JSON.stringify(newmediasurl) ||
    JSON.stringify(newmedias)!==JSON.stringify(oldmedias);
}